export default __webpack_public_path__ + "static/media/4-min.e79ff6dc.jpg";